export default __webpack_public_path__ + "favicons/mstile-70x70.png";